import React, { Component } from 'react';
import BasicPage from './BasicPage';
import { Card } from 'antd';
import { Link } from 'react-router-dom';

export class AdminDetailPage extends Component {
	componentDidMount() {
		// const { query } = UrlParse(this.props.location.search, true);
		// const { id } = query;
		// if (id) {
		// 	this.props.getAdminById({ id });
		// }
	}

	componentDidUpdate(prevProps) {
		// redirect to mainpage if the hall/bldg_cde is change (from dropdown)
		const {crf_id} = JSON.parse(localStorage.getItem('crf'));
		if (crf_id !== prevProps.drawerReducer.crf_id) {
			this.props.history.push('/admins');
		}
	}

	_getSpecificComponent = () => {
		const { history } = this.props;
		const path = this.props.location.pathname.split('/');
		const pathname = path[path.length - 1];
		switch (true) {
			case (pathname === 'basic'):
				return <BasicPage {...this.props} />;
			default:
				// back to notice board or main page once routes not found
				history.push('/admins');
		}
	}

	render() {
		return (
			<>
				<Card style={{ marginTop: 7 }}>
					<React.Fragment>
						<p style={{ marginBottom: 10, fontSize: 11, color: '#707070' }}>
							<Link
								to="/admins"
								style={{ color: '#0074bc' }}
							>
								Admin Management
							</Link>  / Details </p>
						<h3 style={{ margin: 0, color: '#00080D' }}> Administrator Details</h3>
					</React.Fragment>
				</Card>
				<div className="hall-custom-container">
					<Card style={{ margin: '15px 15px 0' }}>
						{this._getSpecificComponent()}
					</Card>
				</div>
			</>
		);
	}
}

export default AdminDetailPage;
